<template>
	<div class="certificate-list">
		<b-row class="mb-3">
			<b-col cols="3" class="pr0">
				<multiselect
					v-model="filter.depId"
					:options="listWarehouse"
					:multiple="true"
					@select="accept"
					track-by="id"
					:show-labels="false"
					:allow-empty="true"
					label="name"
					:placeholder="$t('promo-to-product.department')"
					class="multiselect-pricing"
				>
				</multiselect>
			</b-col>
			<b-col cols="2" class="pr0">
				<b-form-select v-model="filter.sale"
							   :plain="false"
							   :required="true"
							   :text-field="'name'"
							   :value-field="'id'"
							   @change="typeChanged"
							   data-errormessage-value-missing="Bu maydon to'ldirilishi shart!">

					<template slot="first">
						<option :value="null" disabled selected>
							--Выберите тип отчета--
						</option>
						<option value="sale">{{$t('sale.title')}}</option>
						<option value="byEmployee">{{$t('sidebar.organization-structure.employees')}}</option>
						<option value="QARZGA">{{$t('xAtchot.debt')}}</option>
						<!--<option value="spos">{{$t('sidebar.sales.sponsor')}}</option>-->
						<!--<option value="monthly">Сотрудники</option>-->

					</template>
				</b-form-select>
			</b-col>
			<b-col cols="3" class="pr0" v-if="isEmployee">
				<multiselect
					v-model="filter.employeeId"
					:options="dropdowns.counterparties"
					:multiple="false"
					track-by="id"
					:show-labels="false"
					:allow-empty="true"
					:custom-label="employeeSelectedOption"
					:placeholder="$t('users-l.create.employee')"
					class="multiselect-pricing"
				>
					<template slot="option" slot-scope="option">
						{{ option.option.firstName }} {{option.option.lastName}}
					</template>
				</multiselect>
			</b-col>
			<!--<b-col cols="2" class="pr0" v-if="isEmployee">-->
			<!--<b-form-select-->
			<!--v-model="filter.employeeId"-->
			<!--required-->
			<!--&gt;-->
			<!--<option v-for="(selectOption, indexOpt) in dropdowns.counterparties"-->
			<!--:key="indexOpt"-->
			<!--:value="selectOption"-->
			<!--&gt;-->
			<!--{{ selectOption.firstName }} {{ selectOption.lastName }}-->
			<!--</option>-->
			<!--<template slot="first">-->
			<!--<option :value="null" disabled>&#45;&#45; Сотрудник &#45;&#45;</option>-->
			<!--</template>-->
			<!--</b-form-select>-->
			<!--</b-col>-->
			<b-col cols="2" class="pr0" v-if="isSutochni">
				<b-form-select v-model="filter.type"
							   :plain="false"
							   :required="true"
							   :text-field="'name'"
							   :value-field="'id'"
							   @change="typeChanged"
							   data-errormessage-value-missing="Bu maydon to'ldirilishi shart!">

					<template slot="first">
						<option :value="null" disabled selected>
							--Выберите тип отчета--
						</option>
						<option value="daily">{{$t('sale.daily')}}</option>
						<option value="monthly">{{$t('sale.monthly')}}</option>
						<!--<option value="byEmployee">По сотруднику</option>-->
						<!--<option value="inDateRange">В диапазоне</option>-->
					</template>
				</b-form-select>
			</b-col>


			<!--<masked-input v-model="filter.fromDate"-->
			<!--mask="11-11-1111"-->
			<!--class="ml-1 form-control form-control-sm"-->
			<!--:placeholder=" $t('warehouse.date.start')"/>-->
			<!--<b-input-group-addon>-->
			<!--<b-input-group-text>-->
			<!--<i class="fa fa-calendar"></i>-->
			<!--</b-input-group-text>-->
			<!--</b-input-group-addon>-->
			<date-picker v-model="filter.fromDate"  lang="ru" :placeholder=" $t('warehouse.date.start')" valueType="format"
						 format="DD-MM-YYYY"></date-picker>

			<!--<masked-input v-model="filter.toDate"-->
			<!--mask="11-11-1111"-->
			<!--class="ml-1 form-control form-control-sm"-->
			<!--:placeholder=" $t('warehouse.date.end')"/>-->
			<!--<b-input-group-addon>-->
			<!--<b-input-group-text>-->
			<!--<i class="fa fa-calendar"></i>-->
			<!--</b-input-group-text>-->
			<!--</b-input-group-addon>-->
			<date-picker v-model="filter.toDate" lang="ru" :placeholder="$t('warehouse.date.end')" valueType="format"
						 format="DD-MM-YYYY"></date-picker>

			<!--<b-col cols="2" v-if="isDateRange">-->
			<!--<b-input-group>-->
			<!--<masked-input v-model="filter.start"-->
			<!--mask="11-11-1111"-->
			<!--class="ml-1 form-control form-control-sm"-->
			<!--:placeholder=" $t('warehouse.date.start')"/>-->
			<!--<b-input-group-addon>-->
			<!--<b-input-group-text>-->
			<!--<i class="fa fa-calendar"></i>-->
			<!--</b-input-group-text>-->
			<!--</b-input-group-addon>-->
			<!--</b-input-group>-->
			<!--</b-col>-->

			<!--<b-col cols="2" v-if="isDateRange">-->
			<!--<b-input-group>-->
			<!--<masked-input v-model="filter.end"-->
			<!--mask="11-11-1111"-->
			<!--class="ml-1 form-control form-control-sm"-->
			<!--:placeholder=" $t('warehouse.date.end')"/>-->
			<!--<b-input-group-addon>-->
			<!--<b-input-group-text>-->
			<!--<i class="fa fa-calendar"></i>-->
			<!--</b-input-group-text>-->
			<!--</b-input-group-addon>-->
			<!--</b-input-group>-->
			<!--</b-col>-->
			<b-col cols="1">
				<b-button @click="searchReportClick" variant="primary"><i class="fa fa-search"></i></b-button>

			</b-col>
		</b-row>


		<hr>
	</div>
</template>

<script>
	import MaskedInput from 'vue-masked-input'
	import EmployeesService from "../../../../../services/employees.service";
	import Multiselect from 'vue-multiselect'
	import {mapActions, mapGetters} from "vuex";

	export default {
		name: 'Filter-Pos-Report',

		components: {MaskedInput, Multiselect},
		props: ['employee'],
		data() {
			return {
				selectedDepartment: [],
				filter: {
					depId: [],
					employeeId: null,
					fromDate: '',
					toDate: '',
					type: 'daily',
					sale: 'sale'

				},
				departmentArray: [],
				isDateRange: false,
				isEmployee: false,
				isSutochni: true,
				dropdowns: {
					counterparties: [],
				},
				attr: {}
			}
		},
		// created() {
		// 	this.loadEmploees()
		// },

		mounted() {
			this.fetchMyDepartments();
		},


		computed: {
			...mapGetters('departments', [
				'myDepartments'
			]),
			listWarehouse() {
				return this.myDepartments.filter(item => {
					return item.typeName === 'COMPANY' || item.typeName === 'SHOP';
				})
			}
		},
		methods: {
			employeeSelectedOption(employee) {
				return employee.firstName + ' ' + employee.lastName;
			},
			searchReportClick() {
				this.filter.disabledTable = this.isEmployee;
				this.$emit('filter', this.filter)
			},
			...mapActions('departments', ['fetchMyDepartments']),
			accept() {
				// if (this.filter.depId !== null && Object.keys(this.filter.depId).length !== 0) {
				/*this.filter.depId = this.filter.depId.map((department) => {
						return department.id
					}
				);*/

				// } else {
				// 	this.$vs.notify({
				// 		title: 'Пожалуйста выберите Отдел',
				// 		color: 'warning',
				// 		icon: 'close',
				// 		position: 'top-right'
				// 	});
				// }
				// this.filter = {
				// 	employeeId: null,
				// 		start: '',
				// 		end: '',
				// 		type:'daily'
				//
				// }
				// this.isEmployee = false
				// this.isDateRange = false
			},
			async loadEmploees(departments) {
				this.departmentArray = [];
				if (departments !== undefined) {
					departments.forEach(item => {
						this.departmentArray.push(item.id);
					})
				}
				let data = {
					page: 1,
					limit: 50,
					depIds: this.departmentArray
				}
				await EmployeesService.searchByDepsId(data).then(response => {
					this.dropdowns.counterparties = [];
					for (let i = 0; i < response.data.length; i++) {
						this.dropdowns.counterparties = [...response.data[i].items, ...this.dropdowns.counterparties];
					}
				})
			},
			typeChanged($event) {
				if ($event === 'byEmployee') {
					this.isEmployee = true
					this.isDateRange = true
					this.isSutochni = true;
				} else if ($event === 'inDateRange') {
					this.isEmployee = false
					this.isDateRange = true
				} else if ($event == 'sale') {
					this.isDateRange = true
					this.isSutochni = true
					this.isEmployee = false
					this.employeeId = null;
				} else if ($event == 'spos') {
					this.isDateRange = true
					this.isSutochni = true
					this.isEmployee = false
					this.employeeId = null;
				} else if (($event == 'daily' || $event == 'monthly') && this.isEmployee == true) {
					this.isEmployee = true
				} else {
					this.isEmployee = false
					this.isDateRange = false
				}
				this.$emit("disableTab",$event);
			}
		},
		watch: {
			'filter.depId': {
				handler(newValue) {
					this.loadEmploees(newValue);
				}
			}
		}

	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
	.pr0 {
		padding-right: 0;
	}

	.mx-datepicker {
		padding-left: 20px;
	}
</style>
